// This is using token colors of blue-purple theme of Elice UI Content
// https://www.figma.com/design/dtsncp7RSV7wMqPf3jiCvf/Design-System?node-id=51-10973&node-type=SECTION&t=gCjy5t3c42ojVpyW-0
// TODO: apply theme;
export const primaryColor = '#5D6BB3';
export const secondaryColor = '#0A379B';
export const blackColor = '#031234';
export const main50Color = '#F4F6FF';
export const main100Color = '#DFE1F0';
export const main200Color = '#BEC4E1';
export const main300Color = '#9EA6D1';
export const main400Color = '#7D89C2';
export const main950Color = '#072567';
export const gray50Color = '#FAFAFD';
export const gray100Color = '#F3F4FA';
export const gray200Color = '#F1F1F6';
export const gray300Color = '#D8D8E2';
export const gray400Color = '#9B9BA9';
export const textPrimaryColor = '#1E1E1E';
export const textSecondaryColor = '#363643';
export const textTeriaryColor = '#525265';
export const textQuaternaryColor = '#9FA0B1';
export const quaternaryColor = '#9FA0B1';
export const point3Color = '#8F68F6';
export const KeyElementaryBg = '#9BCAFF';
export const KeyMiddleBg = '#B2B2B2';
export const KeyHighBg = '#0A379B';
